<div
    class="fiberPlus"
    [id]="`boxPlan_tube_${cableCode()}_${tubeNumber()}_${side()}_${fiber().code}`">
    {{ fiber().position }}
    <button
        class="fiberPlus_button"
        [class.fiberPlus_button_selected]="isFiberSelected()"
        [class.fiberPlus_button_unselected]="!isFiberSelected()"
        [class.left-5]="side() === CableDirectionEnum.LEFT"
        [class.right-5]="side() === CableDirectionEnum.RIGHT"
        [disabled]="!isSelectionEnabled()"
        [matTooltip]="!isSelectionEnabled() ? ('synopticPlan.fiberAlreadyLinked' | transloco) : ''"
        (click)="selectFiber()">
        <fa-icon
            size="xs"
            [class]="isSelectionEnabled() ? 'text-custom-blue' : 'text-custom-dark-grey'"
            [icon]="['fas', 'plus']" />
    </button>
</div>
